export const MOBILE_LAYOUT_CONTENT_PADDING_CLASS =
  "pb-[calc(5.25rem+env(safe-area-inset-bottom))] small:pb-0"

export const MOBILE_BOTTOM_NAV_CLASS =
  "fixed inset-x-0 bottom-0 z-50 border-t border-[#E5E5E5] bg-[#FFFFFF]/95 px-3 pb-[max(env(safe-area-inset-bottom),0.5rem)] pt-2 shadow-[0_-12px_35px_-30px_rgba(24,21,18,0.55)] backdrop-blur-xl small:hidden"

export const MOBILE_PRODUCT_STICKY_BOTTOM_CLASS =
  "bottom-[calc(4.75rem+env(safe-area-inset-bottom))] small:bottom-0"

export const MOBILE_PRODUCT_PAGE_PADDING_CLASS =
  "pb-[calc(10rem+env(safe-area-inset-bottom))] small:pb-0"

export const MOBILE_FLOATING_CONTACT_CLASS =
  "fixed bottom-[calc(5.75rem+env(safe-area-inset-bottom))] right-3 z-[80] flex flex-col items-end gap-2 small:bottom-5 small:right-5"
